export const environment = {
  production: false,
  apiBaseUrl: 'https://uat-cftw.vthgdigital.com/api',
  socketUrl: 'https://uat-cftw.vthgdigital.com',
};
